export enum AssistantSearchListItemButton {
    NewReservation = 'NewReservation',
    NewCompany = 'NewCompany',
    NewCustomer = 'NewCustomer',
}
